/* eslint-disable */
let wwwDir = '';
document.addEventListener('deviceready', () => {
  wwwDir = `${window.cordova.file.applicationDirectory}www/`;
}, false);

export { wwwDir };
